import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';
import { Amplify } from 'aws-amplify';
import messages from './messages';
import { getOrder } from '../../../slices/orders';
import styles from './Thankyou.module.scss';
import Tealium from '../../../components/dataLayer/Tealium';
import awsconfig from '../../../aws-exports';
import PrimaryButton from '../../../components/common/PrimaryButton';

Amplify.configure(awsconfig);

const Thankyou = () => {
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const order = useSelector((state) => state.order);

  localStorage.setItem('anonymousId', order.anonymousId);

  useEffect(() => {
    const orderIdFromLocalStorage = localStorage.getItem('orderId');
    if (orderIdFromLocalStorage) {
      dispatch(getOrder(orderIdFromLocalStorage));
      localStorage.removeItem('orderId');
      localStorage.removeItem('orderNumber');
    } else {
      window.location.href = '/';
    }

    localStorage.removeItem('kountSessionId');
  }, [dispatch]);

  const continueShoppingClickHandler = () => {
    window.location.href = '/';
  };

  return (
    <div className={styles['thankyou-container']}>
      <h1 className={styles['thankyou-title']}>
        {formatMessage(messages.title)}
      </h1>
      <p className={styles['thankyou-message']}>
        {formatMessage(messages.messagePt1)}
        <span className={styles['bold-email']} data-private>{order?.customerEmail}</span>
        {formatMessage(messages.messagePt2)}
      </p>
      <div className={styles['continue-shopping-btn-container']}>
        <PrimaryButton
          onClick={continueShoppingClickHandler}
          title={formatMessage(messages.continueShoppingBtnMessage)}
        />
      </div>
      <Tealium isOrderConfirmation />
    </div>
  );
};

export default Thankyou;
